<script>
	import { onMount } from "svelte";
	import { push, pop, replace } from "svelte-spa-router";
	import { shuffle, mean, min } from "lodash";
	import Icon from "svelte-awesome";
	import { faBars } from "@fortawesome/free-solid-svg-icons";
	import Break from "../../components/break/Break.svelte";
	import { onBreak } from "../../components/break/stores";
	import GetRequestApiInstance from "../../services/ServiceRequestApi";
	import GetReactionTimeInstance from "../../services/ServiceReactionTime";
	// instances services
	const requestApiInstance = GetRequestApiInstance();
	const reactionTimeInstance = GetReactionTimeInstance();
	// constantes
	const GAME_NAME = "lights-wall";
	const INITIAL_TIME = 30;
	// paramètres
	export let params = {};
	let difficulty = params.difficulty;
	// variables
	let arrayActualLight = [0,0];
	let bestScore = 0;
	// result
	let result = {
		game_name: GAME_NAME,
		difficulty: difficulty,
		score: 0,
		average_time_reaction: 0,
		best_time_reaction: 0
	};
	let isStart = false;
	let timer = INITIAL_TIME;
	let timeIsStopped = true;
	let arrayReactionTime = [];
	let interval;

	onMount(() => {
		onBreak.set(false);
		bestScore = getScoreMax();
	});
	
	async function getScoreMax() {
		let responseScoreMax = await requestApiInstance.get(`bestResult/${GAME_NAME}/${difficulty}`);
		return responseScoreMax[0].score;
	}

	function initEnd() {
		isStart = false;
		timeIsStopped = true;
		clearInterval(interval);
		result.score = 0;
		arrayActualLight = [0,0];
		timer = INITIAL_TIME;
	}

	function initStart() {
		isStart = true;
		timeIsStopped = false;
	}
	
	function handleStart() {
		if (!isStart) {
			initStart();
			reactionTimeInstance.startTimeReaction();
			startTimer();
			randomLight();
		}
	}
	
	function stop() {
		arrayReactionTime = reactionTimeInstance.getArrayReactionTime();
		reactionTimeInstance.resetArrayReactionTime();

		if(arrayReactionTime.length > 0) {
			result.average_time_reaction = Math.round(mean(arrayReactionTime));
			result.best_time_reaction = min(arrayReactionTime);
		}
		
		timeIsStopped = true;
		push("/ranking/" + GAME_NAME + "/" + difficulty + "/" + btoa("game_name=" + result.game_name + "&difficulty=" + result.difficulty + "&score=" + result.score + "&average_time_reaction=" + result.average_time_reaction + "&best_time_reaction=" + result.best_time_reaction ));
	}

	function startTimer() {
		if(!$onBreak && isStart) {
			interval = setInterval(function () {
				if (timer > 0 && !timeIsStopped) {
					timer--;
				} else if(timer == 0) {
					clearInterval(interval);
					stop();
				}
			}, 1000);
		}
	}

	function handleClicBtn(value) {
		if (isStart) verifyLight(value);
	}

	function random() {
		return Math.floor(Math.random() * 8) + 1;
	}

	function randomLight(value) {
		let indexValueLight = null;
		let actualValueLight = null;

		if(value) {
			indexValueLight = arrayActualLight.indexOf(value);
			actualValueLight = arrayActualLight[indexValueLight];
		}

		if(actualValueLight != null && indexValueLight != null) {
			let randomNum = random();
			while (randomNum == actualValueLight || arrayActualLight.includes(randomNum)) {
				randomNum = random();
			}
			arrayActualLight[indexValueLight] = randomNum;
		} else { // Début de partie
			let randomNum = random();
			if(difficulty == 'hard') {
				arrayActualLight[0] = randomNum;
				randomNum = random();
				while(arrayActualLight[0] == randomNum){
					randomNum = random();
				}
				arrayActualLight[1] = randomNum;
			} else if(difficulty == 'normal' ) {
				arrayActualLight[0] = randomNum;
			}
		}
	}

	function verifyLight(value) {
		if (arrayActualLight.includes(value)) {
			result.score++;
			if (result.score > bestScore) {
				bestScore = result.score;
			}
			timeToReact();
			randomLight(value);
		} else {
			stop();
		}
	}

	function timeToReact() {
		reactionTimeInstance.saveTimeToReact();
	}

	function handleBreakButton() {
		onBreak.set(true);
		timeIsStopped = true;
		initEnd();
	}
</script>

<style>
    .container-lights {
        @apply w-full h-full py-16 relative grid justify-center items-center;
        grid-template-columns: 1fr 1fr 1fr;
    }
    .container-lights > div {
        @apply flex justify-between items-center flex-col;
    }
	.light {
        @apply w-20 h-20 rounded-full bg-gray-800;
    }
    .light-on {
        @apply bg-lightsWall-red;
    }
</style>

<div class="container-global">
	{#if $onBreak}
		<Break gameName={GAME_NAME} difficulty={difficulty} />
	{/if}
	<div class="h-1/5">
		<div class="header">
			<div class="text-right pt-4 m-auto w-5/6">
				<span class="cursor-pointer" on:click={handleBreakButton}>
					<Icon data={faBars} scale="1.4" />
				</span>
			</div>
			<div class="top-header pb-2">
				<span class="font-semibold text-3xl {timer <= 5 ? 'text-red-500' : ''}">
					{timer}s
				</span>
			</div>
			<div class="middle-header px-4 text-center">
				<div>
					<span class="text-2xl">
						Score : {result.score} | Meilleur score : {#await bestScore}-{:then result}{result}{/await}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="h-4/5">
        <div on:click={handleStart} class="container-lights">
            <div class="h-full">
                <div on:mousedown={() => handleClicBtn(1)} class="light {arrayActualLight.includes(1) ? 'light-on' : ''}"></div>
                <div on:mousedown={() => handleClicBtn(2)} class="light {arrayActualLight.includes(2) ? 'light-on' : ''}"></div>
                <div on:mousedown={() => handleClicBtn(3)} class="light {arrayActualLight.includes(3) ? 'light-on' : ''}"></div>
            </div>
            <div class="h-1/2">
                <div on:mousedown={() => handleClicBtn(4)} class="light {arrayActualLight.includes(4) ? 'light-on' : ''}"></div>
                <div on:mousedown={() => handleClicBtn(5)} class="light {arrayActualLight.includes(5) ? 'light-on' : ''}"></div>
            </div>
            <div class="h-full">
                <div on:mousedown={() => handleClicBtn(6)} class="light {arrayActualLight.includes(6) ? 'light-on' : ''}"></div>
                <div on:mousedown={() => handleClicBtn(7)} class="light {arrayActualLight.includes(7) ? 'light-on' : ''}"></div>
                <div on:mousedown={() => handleClicBtn(8)} class="light {arrayActualLight.includes(8) ? 'light-on' : ''}"></div>
            </div>
		</div>
	</div>
</div>